import type { ReactNode } from 'react';
import { clsx } from 'clsx';

export type CalloutProps = { tone: 'info' | 'ok' | 'warn' | 'danger'; children: ReactNode };

const TONES = {
  info: 'border-l-accent bg-accent-quiet',
  ok: 'border-l-ok bg-(--color-ok-quiet)',
  warn: 'border-l-warn bg-(--color-warn-quiet)',
  danger: 'border-l-danger bg-(--color-danger-quiet)',
} as const;

/** A rule-line callout rather than a rounded card: the Swiss direction favours
 *  edges over boxes, and a left rule reads as annotation, not as a dialog. */
export function Callout({ tone, children }: CalloutProps) {
  return (
    <div
      role={tone === 'danger' || tone === 'warn' ? 'alert' : undefined}
      className={clsx(
        'border-l-2 px-(--space-4) py-(--space-3) text-[length:var(--text-small)] text-ink',
        TONES[tone],
      )}
    >
      {children}
    </div>
  );
}
